import Moment from "moment";

export default class DateSelection {

    constructor() {
        this.dateStep = null;
        this.dates = [];
        this.date = Moment();
        this.rangeStart = null;
        this.rangeEnd = null;
    }

    createRange(date) {
        let dates = [];
        let start = Moment(this.rangeStart = this.startOfRange(date));
        let end = Moment(this.rangeEnd = this.endOfRange(date));

        while (start.isSameOrBefore(end)) {
            if (this.isEnabled(start)) {
                var date = {
                    value: start.format('YYYY-MM-DD'),
                    current: this.isCurrent(start)
                };

                dates.push(date);
            }

            start.add(1, this.dateStep);
        }

        this.dates = dates;
    }

    updateRange() {
        if (this.dates.length > 0) {
            let required = !Moment(this.date).isBetween(
                this.rangeStart,
                this.rangeEnd,
                this.dateStep, '[]');

            if (!required) {
                return;
            }
        }

        this.createRange(this.date);
    }

    prevRange() {
        let date = Moment(this.rangeStart).subtract(1, this.dateStep);
        this.createRange(date);
    }

    nextRange() {
        let date = Moment(this.rangeEnd).add(1, this.dateStep);
        this.createRange(date);
    }

    prevDate() {
        return this.changeDate(-1);
    }

    nextDate() {
        return this.changeDate(1);
    }

    changeDate(count) {
        let date = Moment(this.date);
        let dateEnabled = false;

        while (!dateEnabled) {
            date.startOf(this.dateStep).add(count, this.dateStep);
            dateEnabled = this.isEnabled(date);
        }

        this.date = date;
        this.updateRange();
        return this.date;
    }

    setDate(date) {
        this.date = Moment(date);
        this.updateRange();
    }

    isSelected(date) {
        if (this.date) {
            return Moment(this.date).isSame(Moment(date), this.dateStep);
        } else {
            return false;
        }
    }

    isCurrent(date) {
        return Moment().isSame(Moment(date), this.dateStep);
    }

    isEnabled(date) {
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/week-date-selection/date-selection.js